// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'list-number';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M6.344 2.625h10.625M6.344 9h10.625M6.344 15.375h10.625m-15.902-1.87a1.062 1.062 0 1 1 1.027 1.339 1.063 1.063 0 1 1-1.027 1.346m-.036-7.721a1.062 1.062 0 0 1 2.125 0c0 .345-.118.68-.333.949l-1.792 1.176h2.125M1.031 1.031h.532a.538.538 0 0 1 .53.532V5.28m-1.062.001h2.125'
  />
);

export const viewBox = '0 0 18 18';
